module.exports = __webpack_public_path__ + "static/img/2026_Logo_GMBCH.57836fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2026_Logo_GMBCH.jpg
// module id = fvHO
// module chunks = 1